import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';

// @components
import { OKMessage, MESSAGE_TYPE_ASSISTANT } from 'commonsComponents/OKMessage'
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';
import { OKButton } from 'components/commons/OKButton/OKButton'

// @helpers
import { taggingDownloadDocument, taggingSuccessStepRedirect } from '../../helpers/bringAccountTagging';

// @contants
import { STATUSES } from '../../constants/bringAccountConstants';

const { FormattedText, formatText } = i18n;

import './successStep.scss';

export const SuccessStep = ({ immBringAccount, isOffice, isPrivateWeb, tealium, actions }) => {
    const isDownloadDocuemnt = immBringAccount.get('downloadDocumentStatus') === STATUSES.FETCHING;
    const url = '/myprofile/accounts'

    const fileButtonActionText = isOffice
        ? formatText('transfer_account_oficina-transfer_account_from_another_bank_success_screen_download_button_of')
        : formatText('transfer_account-transfer_account_from_another_bank_success_screen_download_button');

    const handleDownloadDocument = () => {
        const documentId = immBringAccount.get('documentId');
        if (isOffice) {
            actions.printTransferDocument(documentId);
            return
        }
        taggingDownloadDocument();
        return actions.downloadTransferDocument(documentId);
    };

    return (
        <div className="transfer-account__success-screen col-xs-offset-1 col-xs-10">
            <WizardSuccess
                isSecondVersion
                tealium={tealium}
                successMessage={formatText('transfer_account-transfer_account_from_another_bank_success_screen_title')}
                successSubMessage={(
                    <div className="transfer-account__success-screen__sub-message">
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_subtitle" />
                    </div>
                )}
                mainButton={{
                    label: formatText('transfer_account-transfer_account_from_another_bank_success_screen_accounts_button'),
                    url
                }}
                doMainButtonCustomEvent={() => taggingSuccessStepRedirect(url)}
            >
                <p className="transfer-account__success-screen__next-steps"><FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_second_text" /></p>

                <div className="transfer-account__success-screen__content">
                    <div className="transfer-account__success-screen__content__items">
                        <div className="transfer-account__success-screen__content__items__item" >
                            <i className='account-bring-bank-account__steps-icon' />
                            <p><FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_first_text" /></p>
                        </div>
                        <div className="transfer-account__success-screen__content__items__item">
                            <i className='account-bring-bank-account__steps-icon account-bring-bank-account__steps-icon--2' />
                            <p><FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_second_text_1" /></p>
                        </div>
                        <div className="transfer-account__success-screen__content__items__item">
                            <i className='account-bring-bank-account__steps-icon account-bring-bank-account__steps-icon--3' />
                            <p><FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_third_text" /></p>
                        </div>
                    </div>
                </div>

                {
                    __CONTACT_CENTER__ && !isOffice && (
                        <OKMessage type={MESSAGE_TYPE_ASSISTANT}>
                            <FormattedText value="transfer_account_cc-transfer_account_from_another_bank_success_screen_disclaimer_cc" />
                        </OKMessage>
                    )
                }

                {(isOffice || isPrivateWeb) && (
                    <div className="transfer-account__success-screen__download-file">
                        <h3>
                            <i className='icons--icon-document-dic' />
                            <FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_doc" />
                        </h3>
                        <div className="transfer-account__success-screen__download-file__information">
                            <p>
                                <FormattedText value="transfer_account-transfer_account_from_another_bank_success_screen_doc_desc" />
                            </p>
                            <div className="transfer-account__success-screen__download-file__button">
                                <OKButton modifier={isOffice ? "primary" : "secondary"} loading={isDownloadDocuemnt} disabled={isDownloadDocuemnt} onClick={handleDownloadDocument}>
                                    {fileButtonActionText}
                                </OKButton>
                            </div>
                        </div>
                    </div>
                )}
            </WizardSuccess>
        </div>
    )
}

SuccessStep.propTypes = {
    immBringAccount: PropTypes.object.isRequired,
    isOffice: PropTypes.bool.isRequired,
    isPrivateWeb: PropTypes.bool.isRequired,
    actions: PropTypes.shape({
        downloadTransferDocument: PropTypes.func.isRequired,
        printTransferDocument: PropTypes.func.isRequired,
    }).isRequired,
};
